import { State } from 'src/redux/reducers/RootReducer';
import makeActionCreator from 'src/lib/makeActionCreator';
import { getEventTicketsData } from 'src/apis/TicketAPI';

export const SET_TAKEN_IDENTIFIERS = 'SET_TAKEN_IDENTIFIERS';
export const setTakenIdentifiers = makeActionCreator(SET_TAKEN_IDENTIFIERS);

export const getEventTicketsAction:
(eventId: number, productId: number) => ThunkedAction<State> =
(eventId: number, productId: number) => async (dispatch: any, getState: any) => {
  if (!eventId || !productId) {
    return;
  }
  const organisation = getState().currentOrganisation.id;
  const response = await getEventTicketsData(organisation, eventId, productId);
  if (response.success) {
    const identifiers = (response.data?.result || response.data || [])
      .map((ticket: any) => ticket['event_tickets.ticket_identifier'])
      .filter(Boolean);
    dispatch(setTakenIdentifiers(identifiers));
  }
};
